import { render, staticRenderFns } from "./brain-circuit.vue?vue&type=template&id=0631d112&"
import script from "./brain-circuit.vue?vue&type=script&lang=js&"
export * from "./brain-circuit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0631d112')) {
      api.createRecord('0631d112', component.options)
    } else {
      api.reload('0631d112', component.options)
    }
    module.hot.accept("./brain-circuit.vue?vue&type=template&id=0631d112&", function () {
      api.rerender('0631d112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/brain-circuit.vue"
export default component.exports